import { Button, Card, Divider, Radio, RadioChangeEvent } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

import React from 'react';
import { createUseStyles } from 'react-jss';
import { theme } from '../../constants/theme';
import { Offer } from '../../slices/financingNeed';
import { Pricing } from '../../pages/Stripe/Payment';
import { useHistory } from 'react-router-dom';
import { trackClickPaywallCta } from '../../utils/analytics';
import { Benefit } from './Benefit';
import { BenefitTitle } from './BenefitTitle';
import { PaymentLinkModal } from '../PaymentLinkModal';

const useStyles = createUseStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
  mainTitle: {
    fontFamily: "'Baloo 2'",
    fontWeight: '600',
    fontSize: '30px !important',
    lineHeight: '31px !important',
    textAlign: 'center',
    marginBottom: '10px',
  },
  offersBox: {
    width: '557px',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'space-between',
    gap: '20px',
  },
  cardHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardTitle: {
    fontFamily: "'Baloo 2'",
    fontWeight: '300',
    fontSize: '1.3vw !important',
    lineHeight: '1 !important',
    textAlign: 'left',
    marginBottom: '1vh !important',
    color: theme.palette.primary,
  },
  cardPrice: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    alignItems: 'baseline',
    gap: '7px',
    width: '100%',
  },
  cardPrice1: {
    fontWeight: '600',
    fontSize: '30px !important',
    lineHeight: '31px !important',
    textAlign: 'left',
    color: '#171717',
  },
  cardPriceCrossed: {
    fontWeight: '600',
    fontSize: '20px !important',
    lineHeight: '21px !important',
    textAlign: 'left',
    color: '#A0ABBB',
    textDecoration: 'line-through',
  },
  cardPrice2: {
    fontFamily: "'Baloo 2'",
    fontWeight: '400',
    fontSize: '12px !important',
    lineHeight: '16px !important',
    textAlign: 'left',
    color: '#A3A3A3',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  offerArgBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '11px',
  },
  offerArgText: {
    fontFamily: "'Baloo 2'",
    fontWeight: '400',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    color: '#292929',
  },
  paymentButton: {
    marginTop: '10px',
    fontWeight: '600',
    fontSize: '18px !important',
    lineHeight: '17.4px !important',
    backgroundColor: theme.palette.primary,
    color: 'white',
    alignContent: 'center',
    height: '64px',
    borderRadius: '5.22px',
    '&:hover': {
      backgroundColor: '#EEF2FF',
    },
  },
  paymentLinkButton: {
    marginTop: '10px',
    fontWeight: '500',
    fontSize: '16px !important',
    lineHeight: '17.4px !important',
    backgroundColor: 'white',
    color: theme.palette.primary,
    border: `2px solid ${theme.palette.primary}`,
    alignContent: 'center',
    height: '48px',
    borderRadius: '5.22px',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f8f9ff',
      borderColor: '#3730a3',
      color: '#3730a3',
    },
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  remark: {
    color: 'black',
    fontWeight: '400',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    marginTop: '20px',
  },
  offersTitleComplete: {
    fontFamily: "'Baloo 2'",
    fontWeight: '600',
    fontSize: '1.7vw !important',
    lineHeight: '1 !important',
    textAlign: 'center',
    marginBottom: '1vh !important',
    textDecoration: 'underline',
    textDecorationColor: '#10B981',
    textUnderlineOffset: '0.5vw',
    textDecorationThickness: '0.2vw',
  },
  title: {
    fontFamily: "'Baloo 2'",
    fontWeight: '600',
    fontSize: '1.6875vw !important',
    lineHeight: '1 !important',
    margin: '0 0 15px 0 !important',
    textAlign: 'center',
  },
  subtitle: {
    // fontWeight: 'bold',
    fontSize: '1.4vw',
    lineHeight: 1,
    marginBottom: '4.26%',
  },
  discount: {
    fontWeight: 'bold',
    fontSize: 'calc(5px + 0.6vw)',
    lineHeight: 1,
    color: '#ff2255',
  },
  text: {
    fontWeight: 'bold',
    fontSize: 'calc(5px + 0.6vw)',
    lineHeight: 1,
  },
  offersRow: {},
  cardVisibility: {
    borderRadius: '5%',
    backgroundColor: 'white',
    paddingTop: '5vh',
    paddingBottom: '3vh',
  },
  cardComplete: {
    borderRadius: '5%',
    backgroundColor: 'white',
    paddingTop: '5vh',
    paddingBottom: '3vh',
    '&:hover': {
      boxShadow: '0px 0px 50px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
    },
  },
  table: {
    margin: '0 10vh',
    '& tr': {
      '& td': {
        paddingBottom: '2%',
      },
    },
  },
  radioGroup: {
    '& .ant-radio-button-wrapper': {
      // no border
      border: 'none',
    },
    '& .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)':
      {
        color: '#4F46E5 !important',
        background: '#EEF2FF !important',
        borderRadius: '6px',
        border: 'none',
      },
    '& .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before':
      {
        backgroundColor: 'transparent !important',
        border: 'none !important',
      },
    '& .ant-radio-button-wrapper:not(:first-child)::before': {
      display: 'none',
    },
  },
  card: {
    '& .ant-card-body': {
      padding: '17.4px !important',
    },
  },
});

interface SubscriptionProps {
  projectId: string;
  type: 'ngo' | 'donor';
  offerCompleteExists: string;
  projectName?: string;
}

export const Offers: React.VFC<SubscriptionProps> = ({
  projectId,
  type,
  offerCompleteExists,
  projectName,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [isMonthly, setIsMonthly] = React.useState('true'); // Always monthly now
  const [showPaymentLinkModal, setShowPaymentLinkModal] = React.useState(false);

  function renderArgs() {
    if (type === 'ngo') {
      return (
        <>
          <Benefit value="Aucun engagement de durée. Annulez à tout moment en un clic, sans frais cachés, ni mauvaises surprises." />
          <Benefit value="Travaillez efficacement sur plusieurs projets : Gérez jusqu’à 10 projets simultanément sans perte de productivité." />

          <BenefitTitle value="Trouvez facilement des mécènes et financements :" />
          <Benefit value="Identifiez automatiquement les mécènes* les plus pertinents grâce à nos algorithmes." />
          <Benefit value="Accédez aux fiches mécènes détaillées : Domaines et zones d'intervention, mode opératoire, contact, programmes de soutien... tout ce qu'il faut pour candidater efficacement." />
          <Benefit value="Identifiez les programmes de soutien (appels à projets, prix, bourse etc...)" />

          <BenefitTitle value="Restez toujours à jour :" />
          <Benefit value="Soyez notifié des nouveaux mécènes en France." />
          <Benefit value="Soyez alerté des nouveaux appels à projets, bourses ou prix qui correspondent à vos besoins." />

          <BenefitTitle value="Suivi et gestion de projet simplifiés" />
          <Benefit value="Gardez le contrôle sur l’avancement de vos projets avec notre outil de gestion intuitive." />
          <Benefit value="Déjà des milliers de projets réussis grâce à nous." />
          <Benefit value="Profitez d’un échange individuel pour bien démarrer : conseils pratiques et aide au cadrage de votre recherche." />
        </>
      );
    } else {
      return (
        <>
          <Benefit value="Travaillez sur 10 programmes de soutien (appels à projet, prix, bourse...) simultanément." />
          <Benefit value="Identifiez les associations les plus pertinentes grâce à nos algorithmes." />
          <Benefit value="Soyez notifié par mail des nouvelles assos en France." />
          <Benefit value="Identifiez les appels à projets les plus pertinents." />
          <Benefit value="Soyez notifié par mail des nouveaux appels à projet." />
          <Benefit value="Suivez l'avancement de vos démarches." />
          <Benefit value="Offre sans engagement de durée. Annulable en 1 clic." />
        </>
      );
    }
  }

  function checkoutOffer(annualResource: Pricing, offer: Offer) {
    // Track click on the paywall CTA button
    trackClickPaywallCta();

    history.push(
      `/checkout/${projectId}/${annualResource}/${type}/${offer.toString()}/${isMonthly}`,
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.mainTitle}>
        Gagnez du temps et accélérez vos recherches de{' '}
        {type === 'ngo' ? 'mécènes' : 'porteurs de projet'} pour vos{' '}
        {type === 'ngo' ? 'projets' : 'programmes de soutien'} !
      </div>
      <span
        style={{
          color: theme.palette.primary,
          fontSize: '30px',
          lineHeight: '31.5px',
          fontWeight: '600',
        }}
      >
        Offre Premium
      </span>
      {type === 'ngo' && (
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '4px',
            display: 'none', // Hidden but kept for future use
          }}
        >
          <Radio.Group
            options={[
              {
                label: (
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <>Offre annuelle</>
                    <div
                      style={{
                        backgroundColor: '#ECFDF5',
                        borderRadius: '24px',
                        fontSize: '12px',
                        height: '24px',
                        color: '#10B981',
                        textAlign: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '0 8px',
                      }}
                    >
                      <div>-20%</div>
                    </div>
                  </div>
                ),
                value: 'false',
              },
              { label: 'Offre mensuelle', value: 'true' },
            ]}
            onChange={({ target: { value } }: RadioChangeEvent) => {
              console.log('radio2 checked', value);
              setIsMonthly(value);
            }}
            value={isMonthly}
            optionType="button"
            buttonStyle="solid"
            style={{ marginTop: '0px' }}
            className={classes.radioGroup}
          />
        </div>
      )}
      <Card className={classes.card}>
        <div className={classes.offersBox}>
          <div className={classes.cardHeader}>
            <div
              style={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '20px',
                color: theme.palette.primary,
              }}
            >
              Offre Premium
            </div>
            {isMonthly === 'true' ? (
              <div className={classes.cardPrice}>
                <div className={classes.cardPrice1}>9,90€</div>
                <div className={classes.cardPrice2}>/ mois TTC</div>
              </div>
            ) : (
              <div className={classes.cardPrice}>
                <div className={classes.cardPriceCrossed}>468€</div>
                <div className={classes.cardPrice1}>374€</div>
                <div className={classes.cardPrice2}>/ an TTC</div>
              </div>
            )}
            {type === 'ngo' && (
              <div
                style={{
                  backgroundColor: '#ECFDF5',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  marginTop: '12px',
                  border: '1px solid #10B981',
                }}
              >
                <div
                  style={{
                    color: '#10B981',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '20px',
                  }}
                >
                  🎉 30 jours d&apos;essai gratuit
                </div>
              </div>
            )}
          </div>
          <Divider style={{ margin: '0px' }} />
          <div className={classes.cardBody}>
            {renderArgs()}
            <div className={classes.buttonGroup}>
              <Button
                className={classes.paymentButton}
                onClick={() => checkoutOffer(Pricing.inf100K, Offer.complete)}
                disabled={offerCompleteExists === 'true' ? true : false}
              >
                Activez les fonctionnalités
              </Button>
              <Button
                className={classes.paymentLinkButton}
                icon={<LinkOutlined />}
                onClick={() => setShowPaymentLinkModal(true)}
                disabled={offerCompleteExists === 'true' ? true : false}
              >
                Demander un paiement à un tiers
              </Button>
            </div>
          </div>
        </div>
      </Card>
      {type === 'ngo' && (
        <div className={classes.remark}>
          *(Fondation reconnue publique, fondation d&apos;entreprise, fondation
          abritante, fondation abritée, fonds de dotation, entreprise)
        </div>
      )}
      {type === 'donor' && (
        <div className={classes.remark}>
          * Pour les entreprises, ressources allouées aux mécénats sur
          l’exercice N-1.
        </div>
      )}

      <PaymentLinkModal
        visible={showPaymentLinkModal}
        onCancel={() => setShowPaymentLinkModal(false)}
        projectId={projectId}
        projectName={projectName || 'Untitled Project'}
        type={type}
        offer={Offer.complete.toString()}
        pricing="inf100K"
        isMonthly={isMonthly}
      />
    </div>
  );
};
